__turbopack_context__.v({
  "card": "gaglFG_card",
  "circle": "gaglFG_circle",
  "dot": "gaglFG_dot",
  "dotLate": "gaglFG_dotLate",
  "emptyState": "gaglFG_emptyState",
  "locationName": "gaglFG_locationName",
  "pendingTime": "gaglFG_pendingTime",
  "step": "gaglFG_step",
  "timeline": "gaglFG_timeline",
  "times": "gaglFG_times",
  "vehicleCircle": "gaglFG_vehicleCircle",
});
